import Axios from "axios";
import {
    SET_ASSET_SUMMARY_REPORT_LIST,
    UNSET_ASSET_SUMMARY_REPORT_LIST,
} from "@/store/mutation-types";

import { getAssetSummaryReport } from "@/store/api";

const state = {
    getAssetSummaryReport: [],
};

const getters = {
    getAssetSummaryReport(state) {
        return state.getAssetSummaryReport;
    },
};

const mutations = {
    [SET_ASSET_SUMMARY_REPORT_LIST](state, data) {
        state.getAssetSummaryReport = data;
    },
    [UNSET_ASSET_SUMMARY_REPORT_LIST](state) {
        state.getAssetSummaryReport = [];
    },
};

const actions = {

    getAssetSummaryReport({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getAssetSummaryReport, { params: data})
                .then(function (response) {
                    commit('SET_ASSET_SUMMARY_REPORT_LIST', response.data.data)
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_ASSET_SUMMARY_REPORT_LIST')
                    reject(error);
                })
                .then((always) => {
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
